import * as CONFIG from './config';


exports.getAssignee = function (id) {
    // console.log("getAssignee==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/assignee/getAssignee' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.getAssigneeList = function (id) {
    // console.log("getAssigneeList==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/assignee/AssigneeList' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.addAssignee = function (objModel) {
    // console.log("addAssignee==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/assignee', objModel)
            .then(function (response) {
                // console.log('addAssignee succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('addAssignee err==>',err);
                reject(err);
            });
    });
}

exports.updateAssignee = function (objModel) {
    // console.log("updateAssignee==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/assignee/update', objModel)
            .then(function (response) {
                // console.log('updateAssignee succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateAssignee err==>',err);
                reject(err);
            });
    });
}

exports.deleteAssignee = function (id) {
    // console.log("deleteAssignee==>", id);
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/assignee/delete/' + id)
            .then(function (response) {
                // console.log('deleteAssignee succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('deleteAssignee err==>',err);
                reject(err);
            });
    });
}



// WEBPACK FOOTER //
// ./api/assigneedetails.js